/**
 * @type {import('react-router-dom').NavigateFunction}
 */
export let navigateHelper;

export function setNavigateHelper(navigation) {
  navigateHelper = navigation;
}
